export const ENABLED = 1;
export const DISABLED = 0;



// WEBPACK FOOTER //
// ./js/constants/CouponState.js